// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"Tooltip_tooltipWrapper__3te7t","tooltip":"Tooltip_tooltip__2A0Lu","maxWidth330":"Tooltip_maxWidth330__2Y-rM","maxWidth600":"Tooltip_maxWidth600__1YyhZ"};